import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  layoutWraper: false,
  appUserId: "",
  appUserName: "",
  eventRedirect: "",
};

const LayoutSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setLayoutWraper: (state, { payload }) => {
      state.layoutWraper = payload;
    },
    setAppUserId: (state, { payload }) => {
      state.appUserId = payload;
    },
    setAppUserName: (state, { payload }) => {
      state.appUserName = payload;
    },
    setEventRedirect: (state, { payload }) => {
      state.eventRedirect = payload;
    },
    setHistoryUrl: (state, { payload }) => {
      state.eventRedirect = payload;
    },
  },
});

export const { setLayoutWraper, setAppUserId, setAppUserName, setEventRedirect, setHistoryUrl } =
  LayoutSlice.actions;
export default LayoutSlice.reducer;
